import React, { useContext } from 'react';
import { BsSunFill } from "react-icons/bs"
import { RiMoonFill } from "react-icons/ri"
// import icons
import { social } from '../data';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { ThemeContext } from '../context/ThemeContext';
import { memo } from 'react';

const Socials = () => {
  const { Theme, changeTheme } = useContext(ThemeContext)
  return (
    <ul className='flex space-x-3 lg-space-x-6 '>
      <li>
        <Flex alignItems={"center"} cursor="pointer" h={["37px","37px","43px","43px","43px"]} px="3" onClick={changeTheme} borderRadius={"5px"} background={Theme === 'dark' ? '#F2AA4CFF' : "red.400"} >
          <Icon fontSize={"20px"} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"} as={Theme === "dark" ? BsSunFill : RiMoonFill} />
        </Flex >
      </li>

      <li>
        <Flex alignItems={"center"} h={["37px","37px","43px","43px","43px"]} px="3" borderRadius={"5px"} mr={["10px","10px","30px","0px","0px"]} background={Theme === 'dark' ? '#F2AA4CFF' : "red.400"} >
          <a className={` ${Theme === "dark" ? "text-black.400" : "text-white"}`} href="https://drive.google.com/file/d/18Pxv_xnL2onLThvIK8ofNl5vKKuN1DND/view" target='_blank'>
            <Text fontWeight={"500"} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"}   >

              Resume
            </Text>
          </a>
        </Flex >
      </li>
      {social.map((item, index) => {
        return (
          <li
            className={` hidden lg:flex justify-center items-center ${Theme === "dark" ? "text-black-500" : "text-white"} text-2xl hover:text-white ${Theme === "dark" ? "bg-[#F2AA4CFF]" : "bg-red-400"} border-solid px-3 rounded`}
            key={index}
          >
            <a className='text-xl' href={item.href} target={"blank"}>
              <Icon as={item.icon} color={Theme === 'dark' ? 'blackAlpha.800' : "#fff"} />

            </a>
          </li>
        );
      })}

    </ul>
  );
};

export default memo(Socials);
